// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// const features = [
//   {
//     icon: "%",
//     title: "Interest Rate starting at 12.65%*",
//     desc: "Attractive Loan Interest Rates",
//   },
//   {
//     icon: "₹",
//     title: "No Hidden Charges",
//     desc: "Full Transparency Guaranteed",
//   },
//   { icon: "⏱", title: "Quick Approvals", desc: "Fast Loan Process" },
//   { icon: "0", title: "Zero Pre-payment Charges*", desc: "Close Loan Anytime" },
// ];
// const FeatureCard = ({ icon, title, desc }) => (
//   <div className="col-md-3 d-flex flex-column align-items-center  p-1">
//     <div className="row">
//       <div className="col-3">
//         <div
//           style={{
//             width: "70px",
//             height: "70px",
//             borderRadius: "50%",
//             background: "#fff",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             fontSize: "26px",
//             fontWeight: "600",
//           }}
//         >
//           {icon}
//         </div>
//       </div>
//       <div className="col-9">
//         <h6 className="fw-bold text-center">{title}</h6>
//         <small className="text-center">{desc}</small>
//       </div>
//     </div>
//   </div>
// );

// const Fotter = () => {
//   return (
//     <>
//       {/* DARK BLUE BACKGROUND */}
//       <div
//         style={{
//           background: "#19376D",
//           // paddingTop: "40px",
//           paddingBottom: "60px",
//           position: "relative",
//         }}
//       >
//         {/* FLOATING TOP STRIP */}
//         <div
//           className="container"
//           style={{
//             background: "#EEF3FF",
//             borderRadius: "20px",
//             padding: "35px 40px",
//             boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
//             position: "absolute",
//             top: "-60px",
//             left: "50%",
//             transform: "translateX(-50%)",
//             width: "85%",
//           }}
//         >
//           <div className="row text-center">
//             {features.map((item, index) => (
//               <FeatureCard key={index} {...item} />
//             ))}
//           </div>
//         </div>

//         {/* BLUE SECTION TEXT */}
//         <div
//           className="container text-center text-white pt-5"
//           style={{ marginTop: "80px" }}
//         >
//           <h5 className="fw-bold mb-3">Illustration</h5>

//           <p style={{ maxWidth: "", margin: "0 auto" }}>
//             If your Loan amount is Rs. 1 lakh at an Interest rate of 15%* and
//             tenure of 3 years, your EMI/Installment will be Rs. 3,467 per month.
//           </p>

//           <p className="mt-3" style={{ maxWidth: "900px", margin: "0 auto" }}>
//             For queries reach us at{" "}
//             <a
//               href="#"
//               className="text-white fw-semibold text-decoration-underline"
//             >
//               customercare@subhpaisa.com
//             </a>{" "}
//             or 1800-266-3201
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Fotter;

import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Fotter = () => {
  return (
    <>
      <div className="p-5"
        style={{
          background: "#19376D",
        }}
      >
        <div
          className="container text-center text-white "
        >
          <h5 className="fw-bold mb-3">Illustration</h5>

          <p style={{ maxWidth: "", margin: "0 auto" }}>
            If your Loan amount is Rs. 1 lakh at an Interest rate of 15%* and
            tenure of 3 years, your EMI/Installment will be Rs. 3,467 per month.
          </p>

          <p className="mt-3" style={{ maxWidth: "900px", margin: "0 auto" }}>
            For queries reach us at{" "}
            <a
              href="/"
              className="text-white fw-semibold text-decoration-underline"
            >
              customercare@subhpaisa.com
            </a>{" "}
            or 1800-266-3201
          </p>
        </div>
      </div>
    </>
  );
};

export default Fotter;
